import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

function PurchaseButton(props: {
  outline?: boolean;
  dashed?: boolean;
  children?: ReactNode | ReactNode[];
  grey?: boolean;
  onClick?: () => any;
  icon?: string;
  iconLeft?: boolean;
  link?: string;
  purchaseText?: string;
}) {
    let fillClasses = '';

    if(props.outline) {
      fillClasses += 'border border-solid border-w-2 transition-colors hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2';
      if(props.grey) {
        fillClasses += ' text-dark-grey border-dark-grey hover:bg-dark-grey text-dark-grey focus:ring-dark-grey';
      } else {
        fillClasses += ' text-logo-green border-logo-green hover:bg-logo-green text-logo-green focus:ring-logo-green';
      }
    } else if (props.dashed) {
      fillClasses += 'w-800 h-16 border-dashed border-2 border-logo-green inline-flex place-items-center place-content-center px-6 py-3 mr-2 font-bold text-slate-700 rounded-2xl shadow-sm bg-light-green';

    } else {
      fillClasses += 'border border-transparent text-white focus:outline-none focus:ring-2 focus:ring-offset-2';
      if(props.grey) {
        fillClasses += ' bg-dark-grey hover:bg-dark-grey-hover focus:ring-dark-grey';
      } else {
        fillClasses += ' bg-logo-green hover:bg-logo-green-hover focus:ring-logo-green';
      }
    }

    return (
      <Link
        type="button"
        className={`inline-flex items-center px-6 py-3 mr-2 h-12 font-bold rounded-xl shadow-sm ${fillClasses}`}
        to={props.link ? props.link : '#'}
        onClick={props.onClick}
      >
        <h1 className="text-lg font-bold">{props.purchaseText}</h1>
        { (!props.icon) ? <></> : (
            <img className={`ml-2 ${props.iconLeft ? 'order-first' : ''}`} src={props.icon} alt="" />
        )}
      </Link>
    );
}

export default PurchaseButton;